module.exports = __webpack_public_path__ + "static/maisBrasilBG-cabd7371194b97596608d82a35318fe5.jpg";